import { useEffect } from "react";
import { FeedbackContext } from "@/components/feedback/FeedbackContext";
import { FeedbackForm } from "@/components/feedback/FeedbackForm";
import { FeedbackComparison } from "@/components/feedback/FeedbackComparison";
import { FeedbackProcess } from "@/components/feedback/FeedbackProcess";
import { FeedbackStory } from "@/components/feedback/FeedbackStory";
import { FeedbackFounders } from "@/components/feedback/FeedbackFounders";
import { SampleFormula } from "@/components/sample/SampleFormula";
import "@/components/sample/sample.css";
import { PrivacyFooter } from "@/components/privacy/PrivacyFooter";

export default function Feedback() {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    let robots = document.querySelector('meta[name="robots"]');
    const createdRobots = !robots;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }

    document.title = "Share Your Vitura Feedback";
    description?.setAttribute("content", "Share your experience with the Vitura five-day sample kit.");
    robots.setAttribute("content", "noindex, nofollow");

    return () => {
      document.title = previousTitle;
      if (previousDescription) description?.setAttribute("content", previousDescription);
      if (createdRobots) robots?.remove();
    };
  }, []);

  return (
    <main className="sample-experience min-h-screen bg-[#faf9f5]" data-testid="feedback-page">
      <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
        <FeedbackContext />
        <FeedbackForm />
      </div>
      <FeedbackComparison />
      <FeedbackProcess />
      <FeedbackStory />
      <FeedbackFounders />
      <SampleFormula />
      <PrivacyFooter prefix="feedback" />
    </main>
  );
}
